export const checkMethods = [
  {
    label: "选中",
    value: "真"
  },
  {
    label: "未选中",
    value: "假"
  }
]
